import {withForwardedNavigationParams} from 'react-navigation-props-mapper';
import React from 'react';
import KeyboardAwareScrollView from '../../elements/KeyboardAwareScrollView';
import ScreenContext from '../../ScreenContext';
import NavActions from 'src/actions/NavActions';
import Styles from '../../Styles';
import {
  StyleSheet,
  ScrollView,
  Modal,
  TouchableOpacity,
  View,
  Linking,
  Dimensions,
  Platform,
} from 'react-native';
import {getButtonDescriber} from 'src/components/elements/buttonDescriptor/DescriptorType';
import Localized from 'src/constants/AppStrings';
import AVText from 'src/components/elements/AVText';
import AppRoutes from 'src/AppRoutes';
import ActionsFactory from 'src/actions/ActionsFactory';
import BaseAccountSetupScreenRedesign from 'src/components/screens/BaseAccountSetupScreenRedesign';
import {getDescriber} from '../descriptor/DescriptorType';
import {CampusLocationType} from 'src/components/elements/home/CampusLocationView';
import BluetoothManager, {
  BluetoothEvents,
  BluetoothStates,
} from 'src/services/bluetooth/BluetoothManager';
import MachineStore from 'src/stores/MachineStore';
import BluetoothDeviceTypes from 'src/constants/BluetoothDeviceTypes';
import MachineAction from 'src/actions/MachineActions';
import VendorsExchangeDevice from 'src/services/bluetooth/vendorsExchange/VendorsExchangeDevice';
import BeaconDevice from 'src/services/bluetooth/BeaconDevice';
import TSFInsideDevice from 'src/services/bluetooth/tsfInside/TSFInsideDevice';
import AccountStore from 'src/stores/AccountStore';
import Settings from 'src/Settings';
import LocationHandler from 'src/handlers/LocationHandler';
import LocationErrorStatusOnboarding, {
  LocationErrorStatusType,
} from 'src/components/elements/account/LocationErrorStatusOnboarding';
import {NearbyLocationType} from 'src/components/elements/home/NearbyLocationView';
import NearbyLocationViewOnboarding from 'src/components/elements/account/NearbyLocationViewOnboarding';
import CustomTextInput from 'src/components/elements/CustomTextInput';
import AVTouchableOpacity from 'src/components/elements/AVTouchableOpacity';
import CancelIcon from 'src/components/img/svg/CancelIcon';
import RoundedAppButton, {
  RoundedAppButtonType,
} from 'src/components/elements/RoundedAppButton';
import {getDescriber as getSnackDescriber} from 'src/components/screens/sendSnack/descriptor/sendasnack/DescriptorType';

const {
  getOnBoardingButton,
  getManualLinktxt,
  actionLinkText,
  getBodyTextStyles,
  onboardingLinklocationSuccessTextColor,
} = getDescriber();

type SelectMarketCardLocationProps = {
  code: string;
  data: {id: string; email: string};
  onSuccess: () => void;
};
const screenWidth = Dimensions.get('window').width;
const multipler = Platform.OS === 'web' ? 0.3 : 0.85;
const modalWidth = screenWidth * multipler;
interface SelectMarketCardLocationState {
  locationCode: string;
  isManuallyLinkingLocation: boolean;
  locations: Array<CampusLocationType>;
  bluetoothState: unknown | null;
  locationSelected: number | null;
  isLocationPermissionEnabled: boolean;
  showSuccessMdl?: boolean;
  contentHeight?: number;
}
class SelectMarketCardLocationScreen extends React.Component<
  SelectMarketCardLocationProps,
  SelectMarketCardLocationState
> {
  pollInterval: NodeJS.Timeout | null = null;
  scrollView: KeyboardAwareScrollView | null = null;
  static contextType = ScreenContext;
  declare context: React.ContextType<typeof ScreenContext>;
  isLocationPermissionEnabledRef = false;

  constructor(props: SelectMarketCardLocationProps) {
    super(props);
    this.state = {
      locationCode: '',
      isManuallyLinkingLocation: false,
      locations: [],
      bluetoothState: BluetoothStates.PoweredOff,
      locationSelected: null,
      contentHeight: 0,
      showSuccessMdl: false,
      isLocationPermissionEnabled: false,
    };
    this.linkLocation = this.linkLocation.bind(this);
    this.setLocationId = this.setLocationId.bind(this);
    this.checkPermissions = this.checkPermissions.bind(this);
    this.hideModal = this.hideModal.bind(this);
    this.renderModal = this.renderModal.bind(this);
    this.isLocationPermissionEnabledRef = false;

    MachineStore.addChangeListener(this.onMachineStoreChange.bind(this));
    BluetoothManager.addListener(
      BluetoothEvents.onDeviceFound,
      this.bluetoothDeviceFound.bind(this),
    );
    BluetoothManager.addListener(
      BluetoothEvents.onBTStateUpdate,
      this.bluetoothStateUpdated.bind(this),
    );
  }

  componentDidMount() {
    // // Do not remove - use for testing beacon simulation
    // this.bluetoothDeviceFound({
    //   type: BluetoothDeviceTypes.beacon,
    //   beaconId: 'fffffffffffd',
    // });
    LocationHandler.getCurrentLocation();
    const newPermissionState = LocationHandler.isLocationPermissionEnabled;

    this.isLocationPermissionEnabledRef = newPermissionState;
    this.setState({isLocationPermissionEnabled: newPermissionState});

    this.updateLocations();
  }

  async updatePermissions() {
    LocationHandler.getCurrentLocation();

    const newPermissionState = LocationHandler.isLocationPermissionEnabled;

    if (newPermissionState !== this.isLocationPermissionEnabledRef) {
      this.isLocationPermissionEnabledRef = newPermissionState;
      this.setState({isLocationPermissionEnabled: newPermissionState});
    }
  }

  async checkPermissions() {
    this.context.actions.showSpinner();
    await this.updatePermissions();
    setTimeout(async () => {
      this.context.actions.hideSpinner();
      await this.updatePermissions();
    }, 3000); // short delay for workaround to get the correct location permission status
  }

  componentWillUnmount() {
    MachineStore.removeChangeListener(this.onMachineStoreChange.bind(this));
    BluetoothManager.removeListener(
      BluetoothEvents.onDeviceFound,
      this.bluetoothDeviceFound.bind(this),
    );
    BluetoothManager.removeListener(
      BluetoothEvents.onBTStateUpdate,
      this.bluetoothStateUpdated.bind(this),
    );
    if (this.pollInterval) {
      clearInterval(this.pollInterval);
    }
  }

  async bluetoothDeviceFound(device: {type: string}) {
    if (device.type === BluetoothDeviceTypes.vendorsExchange) {
      MachineAction.deviceAddedVE(device as VendorsExchangeDevice);
    } else if (device.type === BluetoothDeviceTypes.beacon) {
      const beacon = device as BeaconDevice;
      MachineAction.marketScanned(
        beacon.beaconId,
        AccountStore.getAccountId(),
        Settings.buildType,
      );
    } else if (device.type === BluetoothDeviceTypes.tsfInside) {
      const tsfInside = device as TSFInsideDevice;
      if (tsfInside.deviceName) {
        MachineAction.machineAdded(tsfInside);
      } else {
        MachineAction.deviceAdded(tsfInside);
      }
    }
  }
  handleContentLayout = (event) => {
    const {height} = event.nativeEvent.layout;

    this.setState({
      contentHeight: height,
    });
  };
  async checkBluetoothState() {
    const currentState = await BluetoothManager.getBluetoothState();
    if (currentState !== this.state.bluetoothState) {
      this.setState({bluetoothState: currentState});
      if (currentState === BluetoothStates?.PoweredOn) {
        BluetoothManager.startScan();
      } else {
        BluetoothManager.stopScan();
        MachineAction.clearMarkets();
        if (NavActions.getLastRoute() === AppRoutes.NewHome) {
          MachineAction.clearMachines();
          MachineAction.clearDevices();
        }
      }
    }
  }

  bluetoothStateUpdated() {
    this.checkBluetoothState();
  }
  renderModal = (): React.ReactNode => {
    return (
      <Modal
        visible={this.state.showSuccessMdl}
        onDismiss={this.hideModal}
        transparent={true}
      >
        <View style={styles.deleteAcntModalMain}>
          <View
            style={[
              styles.deleteAcntModalContainer,
              {height: this.state.contentHeight + 180},
            ]}
          >
            <AVTouchableOpacity
              aria-label={`X icon, Double tap to ${Localized.Buttons.cancel} offer details`}
              role="button"
              style={styles.closeModalTitleContainer}
              onPress={this.hideModal}
              accessible
              accessibilityLabel={Localized.Buttons.cancel}
              accessibilityRole="button"
            >
              <CancelIcon />
            </AVTouchableOpacity>
            <View
              style={styles.deleteAcntModalContentContainer}
              onLayout={this.handleContentLayout}
            >
              <AVText
                aria-label={`${Localized.Errors.market_card_location_error} label, text`}
                accessibilityLabel={`${Localized.Errors.market_card_location_error} label`}
                style={[
                  {
                    color: '#111',
                    fontSize: Styles.Fonts.sectionHeader + 2,
                    fontWeight: '700',
                    paddingBottom: 8,
                  },
                  getSnackDescriber().snackDetailsBtnFontSTyle(),
                ]}
                accessible={true}
                maxFontSizeMultiplier={Styles.FontSizeMultiplier.maxfm7}
              >
                {Localized.Errors.market_card_location_error}
              </AVText>
              <AVText
                accessible={true}
                accessibilityLabel={`${Localized.Errors.market_card_location_error_description} label`}
                aria-label={`${Localized.Errors.market_card_location_error_description} label, text`}
                style={[
                  {
                    color: '#111',
                    fontSize: Styles.Fonts.f7 - 2,
                    fontWeight: '400',
                    textAlign: 'center',
                    paddingBottom: 24,
                  },
                  getSnackDescriber().snackDetailsBtnFontSTyle(),
                ]}
                maxFontSizeMultiplier={Styles.FontSizeMultiplier.maxfm7}
                numberOfLines={5}
              >
                {Localized.Errors.market_card_location_error_description}
              </AVText>
            </View>

            <View>
              <RoundedAppButton
                buttonType={RoundedAppButtonType.Solid}
                onPress={() => this.hideModal()}
                buttonViewStyle={{
                  overflow: 'hidden',
                  borderRadius: 32,
                  backgroundColor: getButtonDescriber().checkRoundedBtnColor(),
                  borderTopColor: getButtonDescriber().checkRoundedBtnColor(),
                  borderBottomColor:
                    getButtonDescriber().checkRoundedBtnColor(),
                  borderLeftColor: getButtonDescriber().checkRoundedBtnColor(),
                  borderRightColor: getButtonDescriber().checkRoundedBtnColor(),
                  borderColor: getButtonDescriber().checkRoundedBtnColor(),
                  paddingHorizontal: 48,
                  paddingVertical: 10,
                }}
                buttonContainerStyle={{
                  alignSelf: 'center',
                }}
                accessibilityLabelValue={`${Localized.Buttons.try_again}`}
                titleText={Localized.Buttons.try_again}
                maxFontSizeMultiplier={Styles.FontSizeMultiplier.maxfm1}
                textStyle={[
                  {
                    color: Styles.white,
                    fontSize: Styles.Fonts.f1,
                    fontWeight: '700',
                    textAlign: 'center',
                  },
                  getSnackDescriber().snackDetailsBtnFontSTyle(),
                ]}
              />
              <RoundedAppButton
                buttonType={RoundedAppButtonType.Outline}
                onPress={() =>
                  this.setState(
                    {
                      showSuccessMdl: false,
                    },
                    () => {
                      NavActions.pop();
                    },
                  )
                }
                buttonViewStyle={{
                  overflow: 'hidden',
                  borderWidth: 2,
                  borderRadius: 32,
                  borderTopColor: getButtonDescriber().checkRoundedBtnColor(),
                  borderBottomColor:
                    getButtonDescriber().checkRoundedBtnColor(),
                  borderLeftColor: getButtonDescriber().checkRoundedBtnColor(),
                  borderRightColor: getButtonDescriber().checkRoundedBtnColor(),
                  borderColor: getButtonDescriber().checkRoundedBtnColor(),
                  paddingHorizontal: 32,
                  paddingVertical: 10,
                }}
                buttonContainerStyle={{
                  alignSelf: 'center',
                  marginTop: 13,
                }}
                accessibilityLabelValue={`${Localized.Labels.skip_for_now}`}
                titleText={Localized.Labels.skip_for_now}
                maxFontSizeMultiplier={Styles.FontSizeMultiplier.maxfm1}
                textStyle={[
                  {
                    fontWeight: '700',
                    fontSize: Styles.Fonts.f1,
                    color: '#066DFF',
                  },
                  getSnackDescriber().snackDetailsBtnFontSTyle(),
                ]}
              />
            </View>
          </View>
        </View>
      </Modal>
    );
  };
  hideModal = () => {
    this.setState({
      showSuccessMdl: false,
    });
  };
  updateLocations() {
    const machinesList = MachineStore.getMachines();
    const marketsList = MachineStore.getMarkets();
    this.setState({
      locations: [
        ...machinesList,
        ...marketsList,
      ] as unknown as CampusLocationType[],
    });
  }

  onMachineStoreChange() {
    this.updateLocations();
  }

  setLocationId(text: string) {
    this.setState({locationCode: text});
  }

  async linkLocation() {
    const {locationCode} = this.state;
    const {id: accountId} = this.props.data;

    try {
      const location = await ActionsFactory.getAccountActions().getLocationV1(
        locationCode,
      );
      const locationId = location?.data.id;

      const response = await ActionsFactory.getAccountActions().linkLocation(
        accountId,
        locationId,
      );

      const locationResponse =
        await ActionsFactory.getAccountActions().validatePinAndMergeAccounts(
          this.props.data.id,
          '0',
          this.props.code,
          locationId,
        );

      if (locationResponse.message === 'Resource Account with 0 not found') {
        throw new Error(Localized.Errors.invalid_market_card);
      } // temporary work around for detecting location not associated with scan code

      if (response.success && response.data === '') {
        await this.linkLocationSuccess(locationId);
      } else {
        throw new Error(Localized.Errors.failed);
      }
    } catch (error) {
      this.setState({
        showSuccessMdl: true,
      });
    }
  }

  async linkLocationSuccess(locationId: string) {
    const locationName = this.state.isManuallyLinkingLocation
      ? await ActionsFactory.getAccountActions()
          .getAccountLocation(locationId)
          .then((response) => response.displayName)
      : this.state.locations[this.state.locationSelected].displayName;
    const successMessage = Localized.Success.formatString(
      Localized.Success.market_card_link_success_description,
      locationName,
    );
    this.context.actions.showModal(
      successMessage,
      Localized.Success.market_card_link_success,
      Localized.Buttons.okay,
      onboardingLinklocationSuccessTextColor(),
      4,
      false,
      false,
    );
    NavActions.push(AppRoutes.RegistrationEnterPinScreen, {
      onSuccess: this.props.onSuccess,
      data: {id: this.props.data.id, email: this.props.data.email},
      code: this.props.code,
      locationId: locationId,
    });
  }

  renderStandardLinking() {
    return (
      <View style={styles.selectLocation}>
        <View style={styles.selectLocationContent}>
          {this.state.isLocationPermissionEnabled ? (
            this.state.locations.length > 0 ? (
              <ScrollView style={styles.scrollView}>
                <View style={styles.gridContainer}>
                  {this.state.locations.map((location, index) => (
                    <TouchableOpacity
                      key={index}
                      onPress={() => {
                        this.setState((prevState) => ({
                          locationCode: location.locationId,
                          locationSelected:
                            prevState.locationSelected === index ? null : index,
                        }));
                      }}
                      style={styles.locationContent}
                    >
                      <NearbyLocationViewOnboarding
                        nearbyLocation={
                          {
                            locationId: location.locationId,
                            campusId: undefined,
                            displayName: location.displayName,
                            distance: 0,
                            units: undefined,
                          } as NearbyLocationType
                        }
                        selected={this.state.locationSelected === index}
                      />
                    </TouchableOpacity>
                  ))}
                </View>
              </ScrollView>
            ) : (
              <LocationErrorStatusOnboarding
                locationErrorStatusType={
                  LocationErrorStatusType.NoNearbyLocations
                }
              />
            )
          ) : (
            <LocationErrorStatusOnboarding
              locationErrorStatusType={
                LocationErrorStatusType.LocationPermission
              }
            />
          )}
        </View>
        <View style={styles.buttonsAndLinks}>
          {!LocationHandler.isLocationPermissionEnabled ? (
            <View style={{gap: 16, marginTop: -12}}>
              {getOnBoardingButton(
                Localized.Buttons.go_to_settings,
                Linking.openSettings,
              )}
              {getOnBoardingButton(
                Localized.Buttons.check_permissions_again,
                this.checkPermissions,
              )}
            </View>
          ) : this.state.locations.length < 1 ? (
            <View style={{marginTop: -12}}>
              {getOnBoardingButton(
                Localized.Buttons.manually_link_your_location,
                () =>
                  this.setState((prevState) => ({
                    isManuallyLinkingLocation:
                      !prevState.isManuallyLinkingLocation,
                  })),
              )}
            </View>
          ) : (
            <View
              style={
                !this.state.locations ? {marginTop: -12} : {paddingTop: 20}
              }
            >
              {getOnBoardingButton(
                'Next',
                this.linkLocation,
                this.state.locationSelected === null,
              )}
            </View>
          )}
          {(this.state.locations.length > 0 &&
            LocationHandler.isLocationPermissionEnabled) ||
          !LocationHandler.isLocationPermissionEnabled ? (
            <TouchableOpacity
              onPress={() => {
                this.setState((prevState) => ({
                  locationCode: '',
                  locationSelected: null,
                  isManuallyLinkingLocation:
                    !prevState.isManuallyLinkingLocation,
                }));
              }}
              style={styles.skipLinkContainer}
            >
              <View style={actionLinkText()['actionlinkView']}>
                <AVText style={actionLinkText()['actionLinkText']}>
                  {getManualLinktxt()}
                </AVText>
              </View>
            </TouchableOpacity>
          ) : null}
        </View>
      </View>
    );
  }

  renderManuallyLinking() {
    return (
      <View style={styles.manuallyLinkLocation}>
        <ScrollView
          style={styles.scrollView}
          keyboardDismissMode="interactive"
          automaticallyAdjustContentInsets={false}
          keyboardShouldPersistTaps="handled"
        >
          <View style={{marginHorizontal: Styles.Spacing.m3}}>
            <CustomTextInput
              label={Localized.Labels.location_code}
              value={this.state.locationCode}
              accessible={true}
              accessibilityLabel={Localized.Labels.location_code}
              accessibilityValue={{text: this.state.locationCode}}
              accessibilityHint={Localized.Labels.please_enter_location_code}
              onChangeText={(text) => this.setLocationId(text)}
              autoCapitalize="none"
              maxLength={12}
              maxFontSizeMultiplier={Styles.FontSizeMultiplier.maxfm4}
              //textStyle={Platform.OS !== 'web' && Styles.Style.shadow}
              showShadow={true}
              outlineStyle={{
                borderRadius: 8,
                borderWidth: 1,
                borderColor: Styles.neutralHues,
                elevation: 5,
              }}
              containerStyle={{
                marginTop: Styles.Spacing.m2,
                height: Styles.Heights.h4,
              }}
            />
          </View>
          <AVText style={[getBodyTextStyles()['supportingText']]}>
            {Localized.Labels.manually_link_location_description}
          </AVText>
        </ScrollView>
        <View>
          {getOnBoardingButton(
            'Save',
            this.linkLocation,
            this.state.locationCode === '',
          )}
        </View>
      </View>
    );
  }

  onBackSelect = () => {
    if (this.state.isManuallyLinkingLocation) {
      this.setState({isManuallyLinkingLocation: false});
      return;
    } else {
      NavActions.pop();
    }
  };

  render() {
    return (
      <BaseAccountSetupScreenRedesign
        headlineText={
          this.state.isManuallyLinkingLocation
            ? Localized.Labels.link_location
            : Localized.Labels.select_location
        }
        instructionText={
          this.state.isManuallyLinkingLocation
            ? Localized.Labels.link_location_description
            : Localized.Labels.select_location_description
        }
        onBackSelect={this.onBackSelect}
        pop={false}
      >
        {this.state.isManuallyLinkingLocation
          ? this.renderManuallyLinking()
          : this.renderStandardLinking()}
        <>{this.state.showSuccessMdl && this.renderModal()}</>
      </BaseAccountSetupScreenRedesign>
    );
  }
}

const styles = StyleSheet.create({
  locationContent: {
    width: '42%',
    alignItems: 'center',
    justifyContent: 'center',
    maxWidth: 121,
    maxHeight: 100,
    marginLeft: Styles.Spacing.m4,
    marginTop: 24,
    elevation: 2,
  },
  selectLocation: {
    display: 'flex',
    flexDirection: 'column',
    width: 345,
    alignItems: 'center',
    gap: 10,
    flex: 1,
  },
  manuallyLinkLocation: {
    display: 'flex',
    flexDirection: 'column',
    width: 345,
    alignItems: 'center',
    gap: 16,
  },
  spacing: {
    marginBottom: Styles.Spacing.m3,
  },
  selectLocationContent: {
    display: 'flex',
    alignContent: 'center',
    alignItems: 'center',
    gap: 15,
    alignSelf: 'stretch',
  },
  buttonsAndLinks: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: 8,
    alignSelf: 'stretch',
  },
  gridContainer: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    justifyContent: 'flex-start',
    alignItems: 'flex-start',
    gap: Styles.Spacing.m3 + 2,
    paddingTop: 8,
    paddingBottom: 32,
  },
  skipLinkContainer: {
    alignItems: 'center',
    marginTop: 16,
    marginBottom: 24,
  },
  skipLinkText: {
    color: '#007AFF',
    fontSize: 16,
    fontWeight: '600',
  },
  input: {
    alignSelf: 'stretch',
    backgroundColor: Styles.bgColor,
    borderColor: Styles.white,
    borderRadius: 8,
    borderWidth: 1,
    color: Styles.darkColor,
    fontSize: Styles.Fonts.f1,
    height: Styles.Heights.h4,
    paddingHorizontal: Styles.Spacing.m3,
    width: '100%',
  },
  inputsContainer: {
    flexDirection: 'column',
    marginBottom: Styles.Spacing.m5,
    marginHorizontal: Styles.Spacing.m2,
    marginTop: Styles.Spacing.m2,
  },
  negativeBtn: {
    borderColor: Styles.white,
    borderWidth: 1,
    height: Styles.Heights.h5,
    marginVertical: Styles.Spacing.m2,
  },
  override: {
    height: Styles.Heights.h5,
    marginTop: Styles.Spacing.m2,
  },
  scrollView: {
    alignSelf: 'stretch',
    maxHeight: 400,
  },
  nextButtonText: {
    paddingHorizontal: Styles.Spacing.m2,
  },
  deleteAcntModalMain: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
  },
  deleteAcntModalContainer: {
    width: modalWidth,
    backgroundColor: Styles.white,
    borderRadius: Styles.Spacing.m3,
    paddingHorizontal: 12,
  },
  deleteAcntModalContentContainer: {
    marginTop: 50,
    justifyContent: 'center',
    alignItems: 'center',
  },

  closeModalTitleContainer: {
    justifyContent: 'flex-end',
    position: 'absolute',
    top: Styles.Heights.h1 + 4,
    right: Styles.Heights.h1 + 4,
  },
});
export default withForwardedNavigationParams<SelectMarketCardLocationProps>()(
  SelectMarketCardLocationScreen,
);
